import {SubscribeToNewsletterRequest} from './SubscribeToNewsletterRequest.js'

export class NewsRequestsFactory {
  static subscribeToNewsletterRequest = ({email, userEntity} = {}) => {
    const {userId, token} = userEntity?.toJSON() || {}

    return new SubscribeToNewsletterRequest({
      email,
      ...(userId && {userId}),
      ...(token && {token})
    })
  }
}
